export class VehicleMaintenanceScheduleQueryParameters {
  id?: string;
  page?: number;
  pageSize?: number;
  templateHeaderId?: string;
  vehicleId?: string;

  constructor(obj?: VehicleMaintenanceScheduleQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
